import { PartFinderReport } from '@/api/generatedApi';
import { GridColDef } from '@mui/x-data-grid-pro';
import { getCreatorEmailValue } from '@/utils/dataGridValueGetters';
import { RenderCreatedAt, RenderCreator, RenderDescription, RenderPartNumber } from './cellDefinitions';

export const partFinderReportColumns: GridColDef<PartFinderReport>[] = [
  {
    field: 'partNumber',
    headerName: 'Part Number',
    flex: 1,
    minWidth: 150,
    renderCell: RenderPartNumber,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 2,
    minWidth: 200,
    renderCell: RenderDescription,
  },
  {
    field: 'creator',
    headerName: 'Created By',
    flex: 1,
    minWidth: 200,
    renderCell: RenderCreator,
    valueGetter: getCreatorEmailValue,
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    flex: 1,
    minWidth: 150,
    renderCell: RenderCreatedAt,
  },
];
